import React, { useEffect, useState } from "react"
import { useHistory } from "react-router-dom"
import { Card, CardBody, Row, Col, Input, Button } from "reactstrap"
import BootstrapTable from "react-bootstrap-table-next"
import * as moment from "moment"
import TableLoader from "components/Common/TableLoader"
import AffiliateCommissionRulesModal from "./AffiliateCommissionRulesModal"

const formatMoney = value =>
  Number(value || 0).toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })

const EmptyState = ({ icon = "bx bx-user-x", title, subtitle }) => (
  <div className="text-center py-5">
    <i className={icon} style={{ fontSize: "48px", color: "#c3cbe4" }} />
    <h5 className="mt-3 mb-1">{title}</h5>
    {subtitle && <p className="text-muted mb-0">{subtitle}</p>}
  </div>
)

function AffiliatesTable(props) {
  const { data, loading, pagination, page, setPage } = props
  const history = useHistory()

  const [isCommissionRulesOpen, setIsCommissionRulesOpen] = useState(false)
  const [commissionRulesAffiliate, setCommissionRulesAffiliate] = useState(null)

  const columns = [
    // { dataField: "username", text: "Username", sort: true },
    { dataField: "phone_number", text: "Phone Number", sort: true },
    { dataField: "referral_code", text: "Referral Code", sort: true },
    {
      dataField: "joined_at",
      text: "Joined",
      sort: true,
      formatter: cell => (cell ? moment(cell).format("DD/MM/YYYY") : "—"),
    },
    {
      dataField: "affiliate_balance",
      text: "Balance",
      sort: true,
      formatter: cell => formatMoney(cell),
    },
    {
      dataField: "summary.total_signups",
      text: "Signups",
      formatter: (cell, row) => row?.summary?.total_signups ?? 0,
    },
    {
      dataField: "summary.total_earnings",
      text: "Total Earnings",
      formatter: (cell, row) => formatMoney(row?.summary?.total_earnings),
    },
    {
      dataField: "summary.unpaid",
      text: "Unpaid",
      formatter: (cell, row) => formatMoney(row?.summary?.unpaid),
    },
    {
      dataField: "actions",
      text: "Actions",
      formatter: (cell, row) => {
        const openCommissionRules = e => {
          e.stopPropagation()
          setCommissionRulesAffiliate(row)
          setIsCommissionRulesOpen(true)
        }
        return (
          <div className="d-flex gap-2">
            <Button size="sm" color="primary" outline onClick={openCommissionRules}>
              Commission Rules
            </Button>
            <Button size="sm" color="primary" outline onClick={openCommissionRules}>
              <i className="bx bx-pencil" />
            </Button>
          </div>
        )
      },
    },
  ]

  const rowEvents = {
    onClick: (e, row) => {
      history.push(`/affiliate/dashboard/${row.id}/summary`, {
        affiliate: row,
      })
    },
  }

  return (
    <>
      <Card>
        <CardBody>
          <div className="mb-4 h4 card-title">{"Affiliates + Affiliate Rules"}</div>
          {loading ? (
            <TableLoader />
          ) : !data || data.length === 0 ? (
            <EmptyState
              icon="bx bx-user-x"
              title="No affiliates found"
              subtitle="Try adjusting your search or check back later."
            />
          ) : (
            <>
              <div className="table-responsive">
                <BootstrapTable
                  keyField="id"
                  responsive
                  bordered={false}
                  striped={false}
                  classes="table align-middle table-nowrap table-check"
                  headerWrapperClasses="table-light"
                  columns={columns}
                  data={data || []}
                  rowClasses="mytable-hover-row"
                  rowEvents={rowEvents}
                />
              </div>
              {pagination && (
                <Row className="mt-2">
                  <Col className="d-flex justify-content-end align-items-center gap-2">
                    <span className="text-muted">
                      Page {pagination.current_page} of {pagination.last_page} (
                      {pagination.total} total)
                    </span>
                    <button
                      className="btn btn-sm btn-outline-secondary"
                      disabled={page <= 1}
                      onClick={() => setPage(page - 1)}
                    >
                      Prev
                    </button>
                    <button
                      className="btn btn-sm btn-outline-secondary"
                      disabled={page >= pagination.last_page}
                      onClick={() => setPage(page + 1)}
                    >
                      Next
                    </button>
                  </Col>
                </Row>
              )}
            </>
          )}
        </CardBody>
      </Card>
    
      {isCommissionRulesOpen && commissionRulesAffiliate && (
        <AffiliateCommissionRulesModal
          isOpen={isCommissionRulesOpen}
          setIsOpen={setIsCommissionRulesOpen}
          affiliate={commissionRulesAffiliate}
        />
      )}
    </>
  )
}

export default AffiliatesTable
